export default __webpack_public_path__ + "static/media/payment.a19f5a77.gif";